import SliderArea from './sliderArea';

import './sliderArea.css';

export default SliderArea;
